import { ClearSharp, SearchSharp } from '@mui/icons-material'
import { Box, Button, CircularProgress, colors, MenuItem, Select, TextField, Typography } from '@mui/material'
import axios from 'axios'
import React, { useEffect, useState } from 'react'
import Header from '../components/Header'
import Tabs from '../components/Tabs'
import { format } from 'date-fns'
import { useHistory } from 'react-router-dom'
import useQuery from '../components/useQuery'
// Earlier implementation: single date picker, replaced by Year / Month / Day drop-downs as in the mockup
// import ReactDatePicker from 'react-datepicker'
// import 'react-datepicker/dist/react-datepicker.css';

// Year / Month / Day drop-downs, same lists as Fincurator sectorWiseFilings.jsp (years from this year back to 2000)
const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
const yearOptions = []
for (let year = new Date().getFullYear(); year >= 2000; year--) yearOptions.push(year)

// Sector Screen: pending USinMinutes autodrafts under the eight sectors from mst_sic
const SectorScreen = () => {

    const history = useHistory()

    // Back from the status page opens /sector-screen?date=yyyy-MM-dd&form_type=...&company_name=...
    // Start from that search when it is there, otherwise from today and 8-K
    const query = useQuery()
    const queryDateParts = (query.get('date') || '').split('-')
    const startDate = queryDateParts.length === 3 ? new Date(Number(queryDateParts[0]), Number(queryDateParts[1]) - 1, Number(queryDateParts[2])) : new Date()
    const startCountry = query.get('country') || 'US'
    const startFormType = query.get('form_type') || (startCountry === 'IN' ? 'Quarterly' : '8-K')
    const startCompanyName = query.get('company_name') || ''

    const [loading, setLoading] = useState(false)
    // Earlier implementation
    // const [draftDate, setDraftDate] = useState(new Date())
    // const [draftYear, setDraftYear] = useState(new Date().getFullYear())
    // const [draftMonth, setDraftMonth] = useState(new Date().getMonth() + 1)
    // const [draftDay, setDraftDay] = useState(new Date().getDate())
    // const [formType, setFormType] = useState('8-K')
    const [draftYear, setDraftYear] = useState(startDate.getFullYear())
    const [draftMonth, setDraftMonth] = useState(startDate.getMonth() + 1)
    const [draftDay, setDraftDay] = useState(startDate.getDate())
    const [formType, setFormType] = useState(startFormType)
    const [country, setCountry] = useState(startCountry)

    // Only the days of the selected month, so a date like 31 February cannot be picked
    const daysInMonth = new Date(draftYear, draftMonth, 0).getDate()
    const dayOptions = []
    for (let day = 1; day <= daysInMonth; day++) dayOptions.push(day)

    const changeYearMonth = (year, month) => {
        setDraftYear(year)
        setDraftMonth(month)
        const lastDay = new Date(year, month, 0).getDate()
        if (draftDay > lastDay) setDraftDay(lastDay)
    }
    // Earlier implementation
    // const [companyName, setCompanyName] = useState('')
    const [companyName, setCompanyName] = useState(startCompanyName)
    const [sectors, setSectors] = useState([])
    const [draftList, setDraftList] = useState([])
    // The search that produced the current list, so the sector heading opens the status table for that same search
    const [searchedParams, setSearchedParams] = useState({})

    useEffect(() => {
        // Earlier implementation
        // fetchSectorList(new Date(), '8-K', '')
        fetchSectorList(startDate, startFormType, startCompanyName, startCountry)
    }, [])

    const fetchSectorList = (date, form, company, selectedCountry) => {
        const params = {
            date: date ? format(date, "yyyy-MM-dd") : null,
            form_type: form || null,
            company_name: company || null,
            country: selectedCountry || 'US',
        }
        setLoading(true)
        setDraftList([])
        setSearchedParams(params)
        // Keep the current search on the address. Browser back from Edit Article then restores this date and these filters.
        const addressQuery = new URLSearchParams()
        if (params.date) addressQuery.append('date', params.date)
        if (params.form_type) addressQuery.append('form_type', params.form_type)
        if (params.company_name) addressQuery.append('company_name', params.company_name)
        if (params.country) addressQuery.append('country', params.country)
        const nextAddress = `/sector-screen?${addressQuery.toString()}`
        if (`${history.location.pathname}${history.location.search}` !== nextAddress) {
            history.replace(nextAddress)
        }
        axios.get(`/api/filings/sector-screen`, { params })
            .then((resp) => {
                let { rows, sectors } = resp.data.message;
                console.log("Sector Screen ::", resp.data.message)
                setSectors(sectors || [])
                setDraftList(rows || [])
            }).catch(err => console.log("Error :::", err))
            .finally(() => setLoading(false))
    }

    const resetSearchBar = () => {
        // Earlier implementation
        // setDraftDate(new Date())
        setDraftYear(new Date().getFullYear())
        setDraftMonth(new Date().getMonth() + 1)
        setDraftDay(new Date().getDate())
        setFormType('8-K')
        setCountry('US')
        setCompanyName('')
        fetchSectorList(new Date(), '8-K', '', 'US')
    }

    const switchCountry = (nextCountry) => {
        const nextFormType = nextCountry === 'IN' ? 'Quarterly' : '8-K'
        setCountry(nextCountry)
        setFormType(nextFormType)
        fetchSectorList(new Date(draftYear, draftMonth - 1, draftDay), nextFormType, companyName, nextCountry)
    }

    const openSectorStatus = (sectorGroupId) => {
        const query = new URLSearchParams({ sector_group_id: sectorGroupId })
        if (searchedParams.date) query.append('date', searchedParams.date)
        if (searchedParams.form_type) query.append('form_type', searchedParams.form_type)
        if (searchedParams.company_name) query.append('company_name', searchedParams.company_name)
        if (searchedParams.country) query.append('country', searchedParams.country)
        history.push(`/sector-screen/status?${query.toString()}`)
    }

    return (
        <>
            <Header />
            <Tabs />

            {/* Search Bar  */}
            <Box display='flex' justifyContent='flex-start' alignItems='center' textAlign='left' mx={0.5} my={0.5} px={1} py={0.5} bgcolor={colors.blueGrey[50]} fontSize={13} sx={{ gap: '16px', borderRadius: 1 }}>
                <Box>
                    <Box fontWeight={700} fontSize={12} pb={0.25}>Country</Box>
                    <Select variant='outlined' size='small' value={country} style={{ width: 100, backgroundColor: '#FFF' }} onChange={(e) => switchCountry(e.target.value)}>
                        <MenuItem value='US'>US</MenuItem>
                        <MenuItem value='IN'>India</MenuItem>
                    </Select>
                </Box>
                {/* Earlier implementation
                <Box>
                    <Box fontWeight={700} fontSize={12} pb={0.25}>Date</Box>
                    <ReactDatePicker
                        id="SectorScreenReactDatePicker"
                        className="ReactDatePicker"
                        dateFormat="yyyy-MM-dd"
                        selected={draftDate}
                        onChange={(date) => setDraftDate(date)}
                    />
                </Box> */}
                <Box>
                    <Box fontWeight={700} fontSize={12} pb={0.25}>Year</Box>
                    <Select variant='outlined' size='small' value={draftYear} style={{ width: 100, backgroundColor: '#FFF' }} onChange={(e) => changeYearMonth(e.target.value, draftMonth)}>
                        {yearOptions.map(year => <MenuItem key={year} value={year}>{year}</MenuItem>)}
                    </Select>
                </Box>
                <Box>
                    <Box fontWeight={700} fontSize={12} pb={0.25}>Month</Box>
                    <Select variant='outlined' size='small' value={draftMonth} style={{ width: 140, backgroundColor: '#FFF' }} onChange={(e) => changeYearMonth(draftYear, e.target.value)}>
                        {monthNames.map((month, idx) => <MenuItem key={month} value={idx + 1}>{month}</MenuItem>)}
                    </Select>
                </Box>
                <Box>
                    <Box fontWeight={700} fontSize={12} pb={0.25}>Day</Box>
                    <Select variant='outlined' size='small' value={draftDay} style={{ width: 80, backgroundColor: '#FFF' }} onChange={(e) => setDraftDay(e.target.value)}>
                        {dayOptions.map(day => <MenuItem key={day} value={day}>{day}</MenuItem>)}
                    </Select>
                </Box>
                <Box>
                    <Box fontWeight={700} fontSize={12} pb={0.25}>Form Type</Box>
                    <Select variant='outlined' size='small' value={formType} style={{ width: 120, backgroundColor: '#FFF' }} onChange={(e) => setFormType(e.target.value)}>
                        {country === 'IN' && <MenuItem value='Quarterly'>Quarterly</MenuItem>}
                        {country === 'IN' && <MenuItem value='Annual'>Annual</MenuItem>}
                        {country !== 'IN' && <MenuItem value='8-K'>8-K</MenuItem>}
                        {country !== 'IN' && <MenuItem value='10-Q'>10-Q</MenuItem>}
                        {country !== 'IN' && <MenuItem value='10-K'>10-K</MenuItem>}
                    </Select>
                </Box>
                <Box width='20%'>
                    <Box fontWeight={700} fontSize={12} pb={0.25}>Company Name</Box>
                    <TextField variant='outlined' sx={{ backgroundColor: '#FFF' }} size='small' fullWidth name="company_name" value={companyName} onChange={e => { setCompanyName(e.target.value) }} />
                </Box>
                <Box display="flex" flexDirection="column">
                    <Button variant='outlined' color="secondary" sx={{ fontSize: 12, my: 0.25, px: 1, py: 0 }} endIcon={<SearchSharp fontSize='small' color='secondary' />} title='Search For Results' onClick={() => fetchSectorList(new Date(draftYear, draftMonth - 1, draftDay), formType, companyName, country)} >search</Button>
                    <Button variant='outlined' color="info" sx={{ fontSize: 12, my: 0.25, px: 1, py: 0 }} endIcon={<ClearSharp fontSize='small' color='info' />} title='Reset Search Bar' onClick={resetSearchBar} >clear</Button>
                </Box>
            </Box>

            {loading ? <Box display="flex" justifyContent="center" alignItems="center" margin="15%"><CircularProgress /></Box> :
                <>
                    {draftList.length === 0 &&
                        <Box width="100%" textAlign="center" my={1}>
                            <Typography variant='body1' color={colors.deepOrange[300]}>No results found</Typography>
                        </Box>
                    }

                    {/* SECTOR COLUMNS */}
                    <Box display='flex' alignItems='flex-start' mx={0.5} sx={{ gap: '4px' }}>
                        {sectors.map(sector => {
                            const sectorDrafts = draftList.filter(draft => String(draft.sector_group_id) === String(sector.sector_group_id))
                            return (
                                <Box key={sector.sector_group_id} width={`${100 / sectors.length}%`} border={1} borderColor="#CCC" borderRadius={1} fontSize={12}>
                                    <Box
                                        onClick={() => openSectorStatus(sector.sector_group_id)}
                                        px={0.5} py={0.75} fontWeight={700} textAlign='center' bgcolor={colors.blueGrey[100]} color={colors.indigo[800]}
                                        style={{ cursor: 'pointer', textDecoration: 'underline' }}
                                        role="button"
                                        title={`${sector.sector_group} Autodraft Status`}>
                                        {sector.sector_group}
                                    </Box>
                                    <Box height={520} overflow="auto" px={0.5}>
                                        {sectorDrafts.length > 0 ?
                                            sectorDrafts.map((draft, draftIndex) =>
                                                <Box key={`${draft.id}-${draft.irk_omp}`} py={0.5} borderBottom={1} borderColor="#EEE" textAlign='left'>
                                                    {/* Earlier implementation: the rank sat against the company name, and there was no row number */}
                                                    {/* {draft.sector_priority !== null && <span>{draft.sector_priority}&nbsp;</span>} */}
                                                    {/* Earlier implementation */}
                                                    {/* <span style={{ display: 'inline-block', minWidth: '2.2em', marginRight: 10, color: colors.blueGrey[400] }}>{draftIndex + 1}.</span> */}
                                                    {/* Row number is gray with a closing parenthesis. The rank stays dark, with a gap between them. */}
                                                    <span style={{ display: 'inline-block', minWidth: '2.2em', marginRight: 10, color: colors.blueGrey[400] }}>{draftIndex + 1})</span>
                                                    {draft.sector_priority !== null && <span style={{ display: 'inline-block', marginRight: 8 }}>{draft.sector_priority}</span>}
                                                    {draft.id ?
                                                        <span
                                                            onClick={() => history.push(`/articles/edit/${draft.id}`)}
                                                            style={{ cursor: 'pointer', color: colors.blue[800] }}
                                                            role="button"
                                                            title='Edit Article'>
                                                            {draft.company_confirmed_name || draft.company_name}
                                                        </span>
                                                        : <span>{draft.company_confirmed_name || draft.company_name}</span>
                                                    }
                                                    {draft.ticker && <span>&nbsp;[{draft.ticker}]</span>}
                                                </Box>
                                            )
                                            : <Box py={1} textAlign='center' color={colors.blueGrey[400]}>No pending autodrafts</Box>
                                        }
                                    </Box>
                                </Box>
                            )
                        })}
                    </Box>
                </>}
        </>
    )
}

export default SectorScreen
